import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCulturesPhyto.success: {
            return action.payload;
        }

        case constants.getCulturesPhyto.error: {
            return initialState;
        }

        case constants.getCulturesPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}